/*
 * @Description:
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2021-10-08 16:26:39
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-04-11 09:26:21
 */
import api from "@/api";
import { setToken, removeToken, getOpenid, setOpenid } from "@/utils/auth";
import { getUrlParams } from "@/utils/index";
const state = {
    userInfo: {},
    loginCard: {
        type: false,
        text: "用户未登录,请先登录"
    }, //登录弹窗
    agreement: [],
    showAgreement: false
};
const mutations = {
    setUserInfo: (state, userInfo) => {
        if (userInfo.phone) {
            sessionStorage.setItem("phone", userInfo.phone);
        }
        if (userInfo.openid) {
            setOpenid(userInfo.openid);
        }
        state.userInfo = userInfo;
    },
    updateLoginCard: (state, status) => {
        state.loginCard = status;
    },
    showAgreement: (state, status) => {
        state.showAgreement = status;
    },
    agreementList: (state, data) => {
        state.agreement = data;
    }
};
const actions = {
    resetToken({ commit }) {
        return new Promise(resolve => {
            commit("SET_TOKEN", "");
            resolve();
        });
    },
    getUserDetail({ commit }) {
        return new Promise(resolve => {
            commit("SET_TOKEN", "");
            resolve();
        });
    },
    login({ commit }, params) {
        return new Promise((res, rej) => {
            api.user.getInfoByCode(params).then(({ data }) => {
                setToken(data.accessToken);
                commit("setUserInfo", data.baseInfo);
                if (data.openid) {
                    setOpenid(data.openid);
                }
                res();
            });
        });
    },
    bindPhone({ commit }, params) {
        return new Promise((res, rej) => {
            api.user.bindPhone(params).then(({ data }) => {
                sessionStorage.setItem("phone", params.phone);
                res();
            });
        });
    },
    loginStatus({ commit }, res) {
        console.log("loginStatus", res);
        if (res.code === 200010 || res.code === 200011) {
            // 患者不存在 去登录/注册
            commit("setUserInfo", res.data.baseInfo);
            commit("updateLoginCard", {
                type: true,
                text: "用户未登录,请先登录",
                code: res.code
            });
            setOpenid(res.data.openid);
        }
        if (res.code === 1001 || res.code === 1002) {
            commit("updateLoginCard", {
                type: true,
                text: "账号登录过期，请重新登录",
                code: res.code
            });
        }
        // if(!getOpenid()){
        //   const appid = getUrlParams('state') || ''
        //   const code = getUrlParams('code') || ''
        //   api.wx.getOpenidByCode({
        //       appid:appid,
        //       code:code
        //   }).then(({data})=>{
        //       setOpenid(data)
        //   })
        // }
        if (res.code === "-1") {
            commit("updateLoginCard", {
                type: true,
                text: "请先绑定手机号",
                button: "去绑定",
                code: res.code
            });
        }
        if (res.code === "-2") {
            commit("updateLoginCard", {
                type: true,
                text: "当前信息不属于该账号，需切换账号查看",
                button: "去切换",
                code: res.code,
                phone: res.phone
            });
        }
    },
    changeLoginCard({ commit }, res) {
        commit("updateLoginCard", res);
    },
    getNotSignAgreement({ commit, state }, res) {
        api.agreement
            .getNotSignAgreement(
                {
                    userType: 2
                },
                true
            )
            .then(({ data }) => {
                if (data && data.length > 0) {
                    commit("showAgreement", true);
                    commit("agreementList", data);
                }
            });
    }
};
export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js